export default function SVGArrow({ ...props }) {
    return (
        <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="Group 211800">
                <path
                    id="Union"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.8369 0.302993C11.4329 -0.100998 10.7779 -0.100998 10.3739 0.302993C9.96994 0.706984 9.96994 1.36198 10.3739 1.76597L17.6963 9.08835H1.03448C0.463154 9.08835 0 9.5515 0 10.1228C0 10.6942 0.463154 11.1573 1.03448 11.1573H17.6471L10.384 18.2241C9.97453 18.6225 9.96556 19.2774 10.364 19.6869C10.7624 20.0964 11.4173 20.1054 11.8268 19.707L20.9152 10.8643C20.9549 10.8256 20.9913 10.784 21.0239 10.74C21.132 10.5949 21.2029 10.4205 21.2226 10.2308C21.2261 10.1974 21.228 10.1638 21.2282 10.1299C21.2285 10.0893 21.2264 10.049 21.222 10.009C21.2022 9.82847 21.136 9.66186 21.0355 9.52145C21.0026 9.47541 20.9658 9.43186 20.9252 9.39133L11.8369 0.302993Z"
                    fill="#2B6EFF"
                />
            </g>
        </svg>
    );
}
